import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import PageTitle from "@/components/Common/PageTitle.vue";
import ProductsFilter from "@/components/Pages/Ecommerce/ProductsGrid/ProductsFilter.vue";
import ProductsGrid from "@/components/Pages/Ecommerce/ProductsGrid/index.vue";
import { useI18n } from "vue-i18n";
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";

// Type definition for translation objects
type TranslationObject = {
  [key: string]: string | TranslationObject;
};

// i18n setup

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductsGridPage',
  setup(__props) {

const { locale } = useI18n();

// Translation files
const translationFiles = {
  en: enTranslations,
  he: heTranslations,
  ar: arTranslations
};

// Direct translation function that bypasses vue-i18n
const directT = (key: string): string => {
  const parts = key.split('.');
  let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
  
  for (const part of parts) {
    if (!result || !(part in result)) {
      console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
      // Fallback to English if translation not found
      let enResult: TranslationObject = translationFiles.en;
      for (const fallbackPart of parts) {
        if (!enResult || !(fallbackPart in enResult)) return key;
        enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
      }
      return typeof enResult === 'string' ? enResult : key;
    }
    result = result[part as keyof typeof result] as TranslationObject;
  }
  return typeof result === 'string' ? result : key;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageTitle, {
      pageTitle: directT('ecommerce.productsGrid.title'),
      subTitle: directT('ecommerce.productsGrid.subTitle')
    }, null, 8, ["pageTitle", "subTitle"]),
    _createVNode(ProductsFilter),
    _createVNode(ProductsGrid)
  ], 64))
}
}

})